export default {
  id: "verification",
  title: "Verification",
  section: "Billing & Reports",
  order: 56,
  keywords: "verification shift verified unverified approval rate program EVV scorecard",
  body: `
## What it is

Verification is the approval scorecard: it lists every clocked-out shift in
a date range and marks it **Verified** (an admin approved it) or
**Unverified** (finished, but nobody has approved it yet). Since only
approved shifts reach billing and payroll, the unverified count is exactly
the work at risk of being missed in the next billing run.

It's **read-only** — approving happens on the Shifts page; this page tells
you where to look.

## How it works

- "Verified" strictly means the shift's status is Approved; "Unverified"
  means Clocked Out. Scheduled and in-progress shifts aren't counted.
- The **summary bar** shows Total, Verified, Unverified, and the
  verification **Rate %** for the range.
- Each row: a shield icon (green = verified), date, caregiver(s),
  client(s), clock-in/out times, program, service code and description, and
  whether the code is Billable or Non-Billable.
- The **Admin filter** scopes to shifts staffed by that admin's caregivers
  and leads — useful for splitting the cleanup by team.

## Step by step: pre-billing sweep

1. Open **Verification**, set the range to the billing month (the This
   Month / Last Week presets cover most cases).
2. Filter Status to **Unverified**.
3. Optionally filter by Admin and share each team's list with its manager.
4. Approve the shifts on the **Shifts** page (or from the calendar).
5. Come back and re-check — the rate should approach 100% before you run
   billing reports.
6. **Download CSV** if you need the list outside the app.
`,
};
